import { AddressInputContainer } from "@/models/interfaces/entity-settings";

// Каноническая форма адреса для payload'а поиска контактов. Совпадает с тем, что
// сервер ожидает в теле POST persons/search/client|project и в InputContainer у
// NewContact (create/update). Для GET persons/search/main эта же форма
// сериализуется в query-параметры (см. PersonApi.searchPerson).
export type RequestAddressContainer = {
    components: { addressNodeId: number; level: number; value: string }[];
    activeLevel: number;
};

// Цепочку из AddressSelectorRefactored (@chainSelected, PascalCase) приводим к
// каноническому объекту (camelCase), оставляя только заполненные уровни.
// Возвращаем null для пустого адреса — чтобы обычный поиск по имени/тегам не менялся.
export function chainToRequestContainer(
    chain: AddressInputContainer | null
): RequestAddressContainer | null {
    if (!chain) {
        return null;
    }
    const components =
        chain.Components
            .filter((c) => (c.Value ?? "").trim().length > 0)
            .map((c) => ({ addressNodeId: c.AddressNodeId, level: c.Level, value: c.Value }));
    if (!components.length) {
        return null;
    }
    return { components, activeLevel: chain.ActiveLevel };
}
